import { useTranslation } from 'react-i18next'
import { showToast } from '@/shared/libs/toast'
import { ImageUploadField } from '@/shared/ui/image-upload-field'

interface TourImageFieldProps {
  label: string
  value: string
  onChange: (url: string) => void
  onUploadingChange: (uploading: boolean) => void
  onPreview: (url: string) => void
}

/** Banner/thumbnail uploader with the tour form's toasts and preview styling. */
export function TourImageField({
  label,
  value,
  onChange,
  onUploadingChange,
  onPreview,
}: TourImageFieldProps) {
  const { t } = useTranslation()

  return (
    <ImageUploadField
      label={label}
      required
      value={value}
      onChange={onChange}
      onUploadSuccess={() => showToast.success(t('tour.imageUploadSuccess'))}
      onUploadError={(message) => showToast.error(message || t('tour.imageUploadFailed'))}
      uploadFailedText={t('tour.imageUploadFailed')}
      onUploadingChange={onUploadingChange}
      onPreview={onPreview}
      buttonSize="sm"
      previewWrapperClassName="min-h-0"
      previewButtonClassName="group relative block w-full cursor-zoom-in rounded-lg border border-zinc-200 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:ring-offset-2"
      previewImageClassName="pointer-events-none h-28 w-full rounded-[inherit] object-cover transition group-hover:opacity-90"
      texts={{
        select: t('tour.selectImage'),
        uploading: t('tour.uploadingImage'),
        empty: '—',
        previewAlt: label,
      }}
    />
  )
}
